"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _utils = require("./utils");

var _ethereumjsUtil = require("ethereumjs-util");

var _addressUtils = require("./helpers/addressUtils");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var toBuffer = function toBuffer(v) {
  if ((0, _ethereumjsUtil.isHexString)(v)) {
    return (0, _ethereumjsUtil.toBuffer)(v);
  }

  return Buffer.from(v);
};

var WalletInterface = /*#__PURE__*/function () {
  function WalletInterface(key) {
    var isPub = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var identifier = arguments.length > 2 ? arguments[2] : undefined;
    var nick = arguments.length > 3 ? arguments[3] : undefined;
    var keystore = arguments.length > 4 ? arguments[4] : undefined;

    _classCallCheck(this, WalletInterface);

    this.nickname = nick !== null && nick !== '' ? nick : '';
    this.keystore = keystore !== null && keystore !== '' ? keystore : '';
    this.identifier = identifier;

    if (!isPub) {
      var _privKey = Buffer.isBuffer(key) ? key : (0, _utils.getBufferFromHex)((0, _utils.sanitizeHex)(key));

      if (!(0, _ethereumjsUtil.isValidPrivate)(_privKey)) throw new Error('Private key does not satisfy the curve requirements (ie. it is invalid)');
      this.privateKey = _privKey;
      this.publicKey = (0, _ethereumjsUtil.privateToPublic)(_privKey);
      this.isPubOnly = false;
    } else {
      var _pubKey = Buffer.isBuffer(key) ? key : (0, _utils.getBufferFromHex)(key);

      if (_pubKey.length !== 20 && !(0, _ethereumjsUtil.isValidPublic)(_pubKey, true)) throw new Error('Invalid public key');
      if (_pubKey.length === 20) this.isAddress = true;
      this.publicKey = _pubKey;
      this.isPubOnly = true;
    }
  }

  _createClass(WalletInterface, [{
    key: "getPrivateKey",
    value: function getPrivateKey() {
      if (this.isPubOnly) throw new Error('public key only wallet');
      return this.privateKey;
    }
  }, {
    key: "getPrivateKeyString",
    value: function getPrivateKeyString() {
      if (this.isPubOnly) throw new Error('public key only wallet');
      return (0, _ethereumjsUtil.bufferToHex)(this.getPrivateKey());
    }
  }, {
    key: "getNickname",
    value: function getNickname() {
      if (this.nickname === '') return '';
      return this.nickname;
    }
  }, {
    key: "getKeystore",
    value: function getKeystore() {
      if (this.keystore === '') return '';
      return this.keystore;
    }
  }, {
    key: "getPublicKey",
    value: function getPublicKey() {
      if (this.isAddress) throw new Error('Address only wallet');
      return this.publicKey;
    }
  }, {
    key: "getPublicKeyString",
    value: function getPublicKeyString() {
      return (0, _ethereumjsUtil.bufferToHex)(this.getPublicKey());
    }
  }, {
    key: "getAddress",
    value: function getAddress() {
      if (this.isAddress) return this.publicKey;
      return (0, _ethereumjsUtil.publicToAddress)(this.publicKey, true);
    }
  }, {
    key: "getAddressString",
    value: function getAddressString() {
      return (0, _ethereumjsUtil.bufferToHex)(this.getAddress());
    }
  }, {
    key: "getChecksumAddressString",
    value: function getChecksumAddressString() {
      return (0, _addressUtils.toChecksumAddress)(this.getAddressString());
    }
  }, {
    key: "signTransaction",
    value: function signTransaction(txParams, signer) {
      if (this.isPubOnly && typeof signer !== 'function') throw new Error('public key only wallets needs a signer');
      return new Promise(function (resolve, reject) {
        signer(txParams).then(resolve).catch(reject); // }
      });
    }
  }, {
    key: "signMessage",
    value: function signMessage(msg, signer) {
      var _this = this;

      if (this.isPubOnly && typeof signer !== 'function') throw new Error('public key only wallets needs a signer');
      return new Promise(function (resolve, reject) {
        if (!_this.isPubOnly) {
          var msgHash = (0, _ethereumjsUtil.hashPersonalMessage)(toBuffer(msg));
          var signed = (0, _ethereumjsUtil.ecsign)(msgHash, _this.privateKey);
          resolve(Buffer.concat([Buffer.from(signed.r), Buffer.from(signed.s), Buffer.from([signed.v])]));
        } else {
          signer(msg).then(resolve).catch(reject);
        }
      });
    }
  }]);

  return WalletInterface;
}();

var _default = WalletInterface;
exports.default = _default;